import * as React from 'react';
import type { ReactNode } from 'react';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';

import { useScreenWidth } from 'hooks';

interface SideBarProps {
  children: ReactNode;
}

const DESKTOP_SIDEBAR_WIDTH = 395;

export const SideBar: React.FC<SideBarProps> = ({ children }) => {
  const { isMobile } = useScreenWidth();

  return (
    <Drawer
      variant="permanent"
      PaperProps={{
        sx: {
          py: '1px',
          boxShadow: (theme) =>
            `inset -1px -1px 0px 0px ${theme.palette.borderColor.main}`,
          borderRadius: 0,
          position: 'static',
          ...(isMobile && {
            border: 'none',
          }),
        },
      }}
      sx={{
        ...(!isMobile && { width: DESKTOP_SIDEBAR_WIDTH }),
      }}
    >
      <Box
        sx={{
          px: 10,
          pt: 12,
          overflow: 'auto',
          ...(!isMobile && { width: DESKTOP_SIDEBAR_WIDTH }),
        }}
      >
        {children}
      </Box>
    </Drawer>
  );
};
